import React, { useState } from "react";
import BackHeader from "@components/header/BackHeader";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { Flex } from "antd";
import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";
import useUserInfoStore from "@store/useUserInfoStore";
import { useNavigate } from "react-router-dom";
import BasicModal from "@components/modal/BasicModal";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";

const Container = styled.div({
  position: "relative",
  // padding: "0 2rem 4.8rem",
});

const ButtonWrapper = styled.div({
  position: "fixed",
  bottom: "2.4rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  zIndex: 1000,
  width: "100%",
  maxWidth: "56rem",
  padding: "0 2rem",
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
});

const ModalText = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.6rem",
  fontWeight: 500,
  lineHeight: "2.4rem",
  paddingBottom: "4.4rem",
});

const ProductPopup = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { getProductPopup } = useApiRequest();
  const [policyModal, setPolicyModal] = useState(false);
  const [accountModal, setAccountModal] = useState(false);
  const lang = window.localStorage.getItem("language");
  const { data: productPopup } = useQuery({
    queryKey: ["productPopup"],
    queryFn: getProductPopup,
  });

  const { userInfo } = useUserInfoStore();

  const isSalesPolicy =
    userInfo?.shipping_fee !== null || userInfo?.free_shipping_fee !== null;

  const isAccount = userInfo?.account_number !== null;

  const handleNavigateRegister = () => {
    if (isSalesPolicy && isAccount) {
      navigate("/register");
    } else if (!isSalesPolicy) {
      setPolicyModal(true);
    } else if (!isAccount) {
      setAccountModal(true);
    }
  };

  return (
    <Container>
      <BackHeader title={""} closeIcon router={"/main-register"} />

      <Image
        src={
          lang === "en" && productPopup?.thumbnail_url_en
            ? productPopup?.thumbnail_url_en
            : productPopup?.thumbnail_url_ko
        }
        width="100%"
        height="100%"
      />

      <ButtonWrapper>
        <BasicButton
          title="2분 만에 판매 시작"
          width="100%"
          point
          onClick={handleNavigateRegister}
        />
      </ButtonWrapper>

      <BasicModal
        open={policyModal}
        setOpen={setPolicyModal}
        activeName="판매자 정책 설정하기"
        activeEvent={() => navigate("/sales-policy")}
        closeName="취소">
        <Flex vertical gap="2rem" align="center">
          <Image src={theme.image.warning_circle_thin.default} size="4.8rem" />
          <ModalText>
            <span>판매자 정책 설정이 안되어 있어요!</span>
            <span>설정을 완료하신 후 등록을 진행해주세요</span>
          </ModalText>
        </Flex>
      </BasicModal>

      <BasicModal
        open={accountModal}
        setOpen={setAccountModal}
        activeName="계좌 등록하기"
        activeEvent={() => navigate("/bank-account-management")}
        closeName="취소">
        <Flex vertical gap="2rem" align="center">
          <Image src={theme.image.warning_circle_thin.default} size="4.8rem" />
          <ModalText>
            <span>계좌 등록이 안되어 있어요!</span>
            <span>계좌등록을 완료하신 후 등록을 진행해주세요</span>
          </ModalText>
        </Flex>
      </BasicModal>
    </Container>
  );
};

export default ProductPopup;
